export const xtrfStatusOptions = [
    {
        value: ['REQUESTED', 'PENDING', 'SENT'],
        label: 'xtrf.page_project_list.filters.status.quote_pending',
    },
    {
        value: ['OPENED', 'REQUESTED_PROJECT', 'ACCEPTED_BY_CUSTOMER'],
        label: 'xtrf.page_project_list.filters.status.in_progress',
    },
    {
        value: ['CLOSED'],
        label: 'xtrf.page_project_list.filters.status.completed',
    },
]

export const xtrfQuotesStatusOptions = [
    {
        value: ['REQUESTED', 'PENDING', 'SENT'],
        label: 'xtrf.page_project_list.filters.status.quote_pending',
    },
]

export const xtrfProjectsStatusOptions = [
    {
        value: ['OPENED', 'REQUESTED_PROJECT'],
        label: 'xtrf.page_project_list.filters.status.in_progress',
    },
    {
        value: ['CLOSED'],
        label: 'xtrf.page_project_list.filters.status.completed',
    },
]

export const QUOTE_PENDING_INDEX = 0
export const IN_PROGRESS_INDEX = 1
export const COMPLETED_INDEX = 2

export const quoteStatus = ['REQUESTED', 'PENDING', 'SENT']

export const projectStatus = ['REQUESTED_PROJECT', 'OPENED', 'CLOSED']
